import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { useQuery } from '@tanstack/react-query';
import { Text } from '@ui';
import { FormattedMessage } from 'react-intl';

import messages from './LoanInformationHeader.messages';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import ProductType from '../../../ui/productType/ProductType';
import { Rate } from '../../../ui/rate';
import { getMaxMonthlyInterestRate } from '../../NewOutstandingView/NewOutstandingView.helpers';
import InternationalisedName from '../InternationalisedName';

export const LoanInformationHeader = ({ accountId }: { accountId: string }) => {
    const stateKey = useStateKey();

    const {
        data: getAccountsResponse,
        isLoading,
        isError
    } = useQuery(getAccountsQueryConfig(stateKey));

    // TODO: Improve loading skeleton
    if (isLoading || isError) return null;
    const account = getAccountsResponse.data?.accounts.find(
        (account) => account.account_id === accountId
    )!;

    if (account) {
        const productType = account.product_type;

        const durationInMonths = getDurationInMonths(account.duration!);

        const interestRate = getMaxMonthlyInterestRate(account);

        return (
            <>
                <Text className="font-med">
                    <FormattedMessage
                        {...messages.greeting}
                        values={{ name: <InternationalisedName /> }}
                    />
                </Text>
                <Text>
                    <FormattedMessage {...messages.yourlookingat} />{' '}
                    <ProductType
                        productType={productType!}
                        durationInMonths={durationInMonths}
                    />
                    <FormattedMessage
                        {...messages.youllPay}
                        values={{
                            approvalInterestRate: <Rate value={interestRate!} />
                        }}
                    />
                </Text>
            </>
        );
    }
    return null;
};
